import styled, { css } from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { Modal } from "components/Modal";
import { CssButton, CssFlex, CssGrid, CssIcon } from "styles/helpers/layout";

import { StepStatus } from "./MultiStepModal.types";

export const StyledModal = styled(Modal)`
  width: 50rem;
  max-width: 100%;
  border-radius: 1rem;
`;

interface StyledStepProps extends ThemeProps {
  $status: StepStatus;
}

export const StyledStepSeparator = styled(CssIcon)<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral._700};
`;

export const StyledStep = styled(CssFlex)<StyledStepProps>`
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;

  ${(props: StyledStepProps) => {
    switch (props.$status) {
      case StepStatus.Active:
        return css`
          color: ${props.theme.palette.primary.brand};
        `;
      case StepStatus.Complete:
        return css`
          color: ${props.theme.palette.secondary.brand};
        `;
      default:
        return css`
          color: ${props.theme.palette.neutral._500};
        `;
    }
  }}
`;

export const StyledHorizontalLine = styled.hr`
  border: 0;
  width: 100%;
  height: 1px;
  background: ${(props: ThemeProps) => props.theme.palette.neutral._800};
`;

export const StyledButtonContainer = styled(CssGrid)`
  column-gap: 1rem;
  align-items: center;
  grid-template-areas: 'cancel-btn . prev-btn next-btn';
  grid-template-columns: auto 1fr auto auto;
`;

export const CancelButton = styled(CssButton)`
  grid-area: cancel-btn;
`;

export const PrevButton = styled(CssButton)`
  grid-area: prev-btn;
`;

export const NextButton = styled(CssButton)`
  grid-area: next-btn;
`;
